import { Box, constants, TextLink } from '@redbubble/design-system';
import React from 'react';
export var TopicNavItem = function (_a) {
    var label = _a.label, Icon = _a.Icon, _b = _a.active, active = _b === void 0 ? false : _b, href = _a.href, onNavItemClick = _a.onNavItemClick;
    return (React.createElement(TextLink, { href: active ? undefined : href, onClick: function () { return onNavItemClick(label); } },
        React.createElement(Box, { display: "flex", flexDirection: "column", textAlign: constants.CENTER, alignItems: "center", flex: "0 0 auto", paddingY: "xxs", paddingX: "xs", paddingTop: "xs", className: [
                'rb-topic-nav__item',
                active ? 'rb-topic-nav__item--active' : undefined,
            ].join(' ') },
            React.createElement(Icon, null),
            React.createElement(Box, { paddingY: "xxxs" }, label))));
};
